/*---------------------------------------*\
   Import classes
\*---------------------------------------*/

//Components
import {Header} from "./Components/Header";
import {ShareArticle} from "./Components/ShareArticle";
import {ContentRules} from "./Components/ContentRules";
import {ThemePopup} from "./Components/ThemePopup";

/*---------------------------------------*\
   Init Functions
\*---------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
    // Float label for smartEmailing form
    Header.init();
    ShareArticle.init();
    ContentRules.init();
    ThemePopup.init();
});
